export const toggleButtonTheme = {
  colorScheme: {
    light: {
      root: {
        checkedColor: 'var(--p-white)',
      },
      content: {
        checkedBackground: 'var(--p-primary-500)',
      },
      icon: {
        checkedColor: 'var(--p-white)',
      },
    },
    dark: {
      root: {
        checkedColor: 'var(--p-white)',
      },
      content: {
        checkedBackground: 'var(--p-primary-500)',
      },
      icon: {
        checkedColor: 'var(--p-white)',
      },
    },
  },
};
